import * as React from 'react';
import * as PropTypes from 'prop-types';
import { classNames } from '@progress/kendo-react-common';
/**
 * @hidden
 */
export var headerDisplayName = 'ActionSheetHeader';
/**
 * The KendoReact ActionSheetHeader component.
 */
export var ActionSheetHeader = function (props) {
    return (React.createElement("div", { className: classNames('k-actionsheet-titlebar', props.className) }, props.children));
};
ActionSheetHeader.propTypes = {
    className: PropTypes.string
};
/**
 * @hidden
 */
ActionSheetHeader.displayName = headerDisplayName;
/**
 * @hidden
 */
ActionSheetHeader.propTypes = {
    children: PropTypes.any
};
